import React from "react";
import { FaPaperPlane, FaArrowUp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="bg-primary text-white pt-10 relative">
            {/* Top Section: Get In Touch */}
            <div className="flex flex-col md:flex-row justify-between items-center px-6 md:px-16 border-b border-gray-700 pb-6">
                <div className="text-center md:text-left">
                    <h2 className="text-xl font-semibold text-blue-400">Get In Touch</h2>
                    <p className="text-lg mt-2 text-gray-300">Enter your email address here...</p>

                    <div className="mt-4 flex flex-col sm:flex-row items-center sm:items-start gap-3">
                        <input
                            type="email"
                            placeholder="you@example.com"
                            className="px-4 py-2 rounded-md text-black w-full sm:w-auto"
                        />
                        <button className="bg-secondary text-black font-semibold px-5 py-2 rounded-md hover:bg-yellow-400">
                            Submit
                        </button>
                    </div>
                </div>

                {/* Vision and Saudi Made Images */}
                <div className="mt-6 md:mt-0 flex justify-center gap-6">
                    <div className="bg-white/90 p-3 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300">
                        <img
                            src="./images/vision.webp"
                            alt="AKTP Vision"
                            className="w-32 h-32 md:w-40 md:h-40 object-contain rounded-lg"
                        />
                    </div>
                    <div className="bg-white/90 p-3 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300">
                        <img
                            src="./images/saudi_made.webp"
                            alt="Saudi Made"
                            className="w-32 h-32 md:w-40 md:h-40 object-contain rounded-lg"
                        />
                    </div>
                </div>
            </div>

            {/* Bottom Section: Info Links */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8 px-6 md:px-16 py-10 text-gray-300">
                {/* Enquiry */}
                <div>
                    <h3 className="text-xl font-bold text-white mb-4">Enquiry</h3>
                    <p>+966 57 018 5488</p>
                    <p className="mt-2">sales@aktp-sa.com</p>
                    <p className="mt-2">info@aktp-sa.com</p>
                </div>


                {/* Reach */}
                <div>
                    <h3 className="text-xl font-bold text-white mb-4">Reach</h3>
                    <p>Al–Khobar Trading Project Est.</p>
                    <p className="mt-1">
                        3<sup>rd</sup> Cross, Prince Muhammad Street,<br />
                        Al-Khobar, Shamalia, Eastern Province,<br />
                        Saudi Arabia - 31952
                    </p>
                </div>

                {/* Useful Links */}
                <div>
                    <h3 className="text-xl font-bold text-white mb-4">Useful Links</h3>
                    <ul className="space-y-2">
                        <li>
                            <Link to="/" className="hover:underline">Home</Link>
                        </li>
                        <li>
                            <Link to="/service" className="hover:underline">Service</Link>
                        </li>
                        <li>
                            <Link to="/about" className="hover:underline">About Us</Link>
                        </li>
                        <li>
                            <Link to="/contact" className="hover:underline">Contact</Link>
                        </li>
                    </ul>
                </div>

                {/* Material Trading */}
                <div>
                    <h3 className="text-xl font-bold text-white mb-4">Material Trading</h3>
                    <ul className="space-y-2 text-white">
                        <li>Electrical Materials</li>
                        <li>Industrial Explosion Proof Materials</li>
                        <li>Hardware Materials</li>
                        <li>Plumbing Materials – PVC products, etc.</li>
                        <li>Consumable Materials</li>
                        <li>PPE products</li>
                        <li>Computer accessories</li>
                        <li>Steel Products</li>
                        <li>GI Products</li>
                        <li>Paints – wall paints, waterproofing (liquid)</li>
                    </ul>
                </div>
                {/* Our Services */}
                <div>
                    <h3 className="text-xl font-bold text-white mb-4">Our Services</h3>
                    <ul className="space-y-2">
                        <li>Electrical Material Mapping & Installation</li>
                        <li>Building Maintenance</li>
                    </ul>
                </div>
            </div>

            {/* Scroll to top */}
            {/* <div className="absolute bottom-5 right-5">
                <button className="bg-blue-500 text-white p-4 rounded-full shadow-lg hover:bg-blue-600 transition duration-300">
                    <FaArrowUp />
                </button>
            </div> */}

            <div className="bg-primary text-center py-4 text-gray-300 text-sm">
                Made with love<span className="text-red-500 mx-1">❤️</span> –{" "}
                <a
                    href="https://sawtcode.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-white transition"
                >
                    Sawtcode Creations
                </a>
            </div>
        </footer>
    );
};

export default Footer;